<template>
  <div class="box" @scroll="handleScroll($event)">
    <Header ref="headerNav" />
    <div class="content">
      <div class="headerbg">
        <span>就业创业服务云平台</span>
        <b>EMPLOYMENT AND ENTREPRENEURSHIP SERVICE CLOUD PLATFORM</b>
      </div>
      <div class="mainbody">
        <div class="setionbox">
          <p>共享、众创、实时、互动、聚合、效率、安全、智能、数据、开放</p>
        </div>
        <div class="setionbox">
          <div class="setion">
            <div class="left">
              <p>创新创就业需要平台化服务</p>
              <div class="line"></div>
              <div class="text">
                启创云面向全国创就业领域，基于云计算技术，依托PAAS平台，提供数据驱动、智慧驱动两大核心应用，功能覆盖共享服务、共享资源等。打通线上培训和线下服务，构建创新创.就业生态系统，大数据智能分析服务。
              </div>
            </div>
            <div class="right">
              <img
                style="width: 574px"
                src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/NewsInformation/img1.png"
                alt=""
              />
            </div>
          </div>
        </div>

        <div class="setionbox">
          <div class="setion">
            <div class="right">
              <img
                style="width: 580px"
                src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/NewsInformation/img2.png"
                alt=""
              />
            </div>
            <div class="left">
              <p>创新创就业服务都在这</p>
              <div class="line"></div>
              <div class="text">
                启创云服务包括了创业政策及资讯、创新创业培训、网络创业培训、创业项目服务、大赛服务等；细化了创.就业服务的各个环节，打通了每个模块的数据交互，直接面对创业者，提高创就业成功率。
              </div>
            </div>
          </div>
        </div>

        <div class="setionbox">
          <div class="setion">
            <div class="left">
              <p>整体培训服务</p>
              <div class="line"></div>
              <div class="text">
                创新创业培训涵盖了创业环境分析、组建高效团队、激发创新思维、把握创业商机、企业开办准备、模拟经营管理、创业质量评估和形成创业计划书八大模块。<br />
                网络创业培训涵盖了买家中心、供销系统、店铺管理、宝贝管理、营销活动、数据分析等模块。
              </div>
            </div>
            <div class="right">
              <img
                style="width: 580px"
                src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/NewsInformation/img3.png"
                alt=""
              />
            </div>
          </div>
        </div>

        <div class="setionbox">
          <div class="setion">
            <div class="right">
              <img
                style="width: 578px"
                src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/NewsInformation/img4.png"
                alt=""
              />
            </div>
            <div class="left">
              <p>虚拟货币服务</p>
              <div class="line"></div>
              <div class="text">
                支持对特定模块特定资源的付费，系统内部统一结算，在线充值银行对接。云币审批、在线充值、云币支付、年度结算、云币流向监控等。
              </div>
            </div>
          </div>
        </div>

        <div class="setionbox">
          <div class="setion">
            <div class="left">
              <p>项目服务</p>
              <div class="line"></div>
              <div class="text">
                创建创业项目库，整合资源智能分析和筛选优秀项目并进行项目跟踪。<br />
                项目路演、项目推介、项目指导、项目孵化及融资，形成一体化的项目解决方案。
              </div>
            </div>
            <div class="right">
              <img
                style="width: 580px"
                src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/NewsInformation/img5.png"
                alt=""
              />
            </div>
          </div>
        </div>

        <div class="setionbox">
          <div class="setion">
            <div class="right">
              <img
                style="width: 589px"
                src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/NewsInformation/img6.png"
                alt=""
              />
            </div>
            <div class="left">
              <p>大赛及活动服务</p>
              <div class="line"></div>
              <div class="text">
                提供线下线上活动支持及一整套的创新创业大赛的服务解决方案及平台支持。<br />
                从大赛的筹备到决赛的流程化管理，参赛项目智能分析和统筹管理，大赛评委专家管理和后期辅导跟踪。
              </div>
            </div>
          </div>
        </div>

        <div class="setionbox">
          <div class="setion">
            <div class="left">
              <p>数据统计与智能分析服务</p>
              <div class="line"></div>
              <div class="text">
                平台数据集中统一管理，多维度多层级数据报表展示，数据分析图表展示。<br />
                实时数据汇总、管理汇报报表、自定义数据输出、智能分析和大数据预测。
              </div>
            </div>
            <div class="right">
              <img
                style="width: 580px"
                src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/NewsInformation/img7.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
export default {
  name: 'NewsInformation',
  methods:{
     handleScroll (e) {
      if(e.srcElement.scrollTop>2){
        this.$refs.headerNav.showHeadBj()
      }else {
        this.$refs.headerNav.hideHeadBj()
      }
      //滚动事件
    },
  }
}
</script>

<style lang="scss" scoped>
.setionbox:nth-child(odd) {
  background: #f8f8f8;
  .left {
    padding-left: 70px;
  }
}
.left {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: start;
  p {
    font-size: 36px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #333333;
  }
  .line {
    margin-top: 20px;
    width: 120px;
    height: 4px;
    background: #f39a21;
  }
  .text {
    width: 468px;
    margin-top: 60px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #666666;
     line-height: 1.8;
  }
}
.right {
  flex: 1;
}
.box {
  width: 100%;
  height: 100%;
  overflow: auto;
  // position: relative;
}
.headerbg {
  width: 100%;
  height: 580px;
  background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/NewsInformation/headerbgi.png");
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  span {
    font-size: 42px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #ffffff;
  }
  b {
    font-size: 32px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #006cda;
  }
}
.setionbox {
  width: 100%;
  // background-color: red;
  .setion {
    margin: 0 auto;
    width: 1200px;
    padding-top: 80px;
    padding-bottom: 80px;
    // background-color: #f5ff;
    display: flex;
  }
}
.mainbody > .setionbox > p {
   line-height: 1.8;
  padding-top: 30px;
  padding-bottom: 30px;
  width: 529px;
  margin: 0 auto;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
  background: #f8f8f8;
  text-align: center;
  display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor:pointer;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
</style>





// WEBPACK FOOTER //
// src/pages/NewsInformation.vue